import { put, call } from "redux-saga/effects";
import { userConstants } from "../actions/constants/userConstants";
import { UserService } from "../services/api/userService";
import { exceptionHandler } from "../pages/common/functions";

function* userSave(request: any) {
	try {
		const result = yield call(UserService.userSave, request.input);
		const res = exceptionHandler(result)
		if (res.status) {
			yield put({
				type: userConstants.UserSaveSuccess,
				payload: res.data,
				user: request.input.user,
				message: res.data.status
			});
		}
		else {
			yield put({ type: userConstants.UserSaveFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: userConstants.UserSaveFailure, payload: error });
	}
}

function* userGetDetail(request: any) {
	try {
		const result = yield call(UserService.userGetDetail, request.input.id, request.input.userName);
		const res = exceptionHandler(result)
		if (res.status) {
			yield put({
				type: userConstants.UserGetDetailSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: userConstants.UserGetDetailFailure, payload: res.data, statusCode:result.status });
		}
	} catch (error) {
		yield put({ type: userConstants.UserGetDetailFailure, payload: error });
	}
}

function* userGetCountByYear(request: any) {
	try {
		const result = yield call(UserService.userGetCountByYear, request.input);
		const res = exceptionHandler(result)
		if (res.status) {
			yield put({
				type: userConstants.UserGetCountByYearSuccess,
				payload: res.data.userCountGetByYear
			});
		}
		else {
			yield put({ type: userConstants.UserGetCountByYearFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: userConstants.UserGetCountByYearFailure, payload: error });
	}
}

function* userGetByFilter(request: any) {
	try {
		const result = yield call(UserService.userGetByFilter, request.input);
		const res = exceptionHandler(result)
		if (res.status) {
			yield put({
				type: userConstants.UserGetByFilterSuccess,
				payload: res.data,
			});
		}
		else {
			yield put({ type: userConstants.UserGetByFilterFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: userConstants.UserGetByFilterFailure, payload: error });
	}
}

function* userDelete(request: any) {
	try {
		const result = yield call(UserService.userDelete, request.input);
		const res = exceptionHandler(result)
		if (res.status) {
			yield put({
				type: userConstants.UserDeleteSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: userConstants.UserDeleteFailure, payload:res.data });
		}
	} catch (error) {
		yield put({ type: userConstants.UserDeleteFailure, payload: error });
	}
}

function* userRoleGetByFilter() {
	try {
		const result = yield call(UserService.userRoleGetByFilter)
		const res = exceptionHandler(result)
		if (res.status) {
			yield put({
				type: userConstants.UserRoleGetByFilterSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: userConstants.UserRoleGetByFilterFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: userConstants.UserRoleGetByFilterFailure, payload: error });
	}
}

function* userRoleGet(request: any) {
	try {
		const result = yield call(UserService.userRoleGet, request.input);
		const res = exceptionHandler(result)
		if (res.status) {
			yield put({
				type: userConstants.UserRoleGetSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: userConstants.UserRoleGetFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: userConstants.UserRoleGetFailure, payload: error });
	}
}


function* userGetAddress(request: any) {
	try {
		const result = yield call(UserService.userGetAddress, request.input);
		const res = exceptionHandler(result)
		if (res.status) {
			yield put({
				type: userConstants.UserGetAddressSuccess,
				payload: res.data.userAddresses
			});
		}
		else {
			yield put({ type: userConstants.UserGetAddressFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: userConstants.UserGetAddressFailure, payload: error });
	}
}

function* userGetPaymentsByFilter(request: any) {
	try {
		const result = yield call(UserService.userGetPaymentsByFilter, request.input);
		const res = exceptionHandler(result)
		if (res.status) {
			yield put({
				type: userConstants.UserGetPaymentSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: userConstants.UserGetPaymentFailure, payload: res.data});
		}
	} catch (error) {
		yield put({ type: userConstants.UserGetPaymentFailure, payload: error });
	}
}

function* userUpdateActiveStatus(request: any) {
	try {
		const result = yield call(UserService.userUpdateActiveStatus, request.input);
		const res = exceptionHandler(result)
		if (res.status) {
			yield put({
				type: userConstants.UserUpdateActiveStatusSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: userConstants.UserUpdateActiveStatusFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: userConstants.UserUpdateActiveStatusFailure, payload: error });
	}
}

function* userSaveCommunity(request: any) {
	try {
		const result = yield call(UserService.userSaveCommunity, request.input);
		const res = exceptionHandler(result)
		if (res.status) {
			yield put({
				type: userConstants.UserSaveCommunitySuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: userConstants.UserSaveCommunityFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: userConstants.UserSaveCommunityFailure, payload: error });
	}
}


function* userSaveAddress(request: any) {
	try {
		const result = yield call(UserService.userSaveAddress, request.input);
		const res = exceptionHandler(result)
		if (res.status) {
			yield put({
				type: userConstants.UserSaveAddressSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: userConstants.UserSaveAddressFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: userConstants.UserSaveAddressFailure, payload: error });
	}
}

function* userRoleSave(request: any) {
	try {
		const result = yield call(UserService.userRoleSave, request.input);
		const res = exceptionHandler(result)
		if (res.status) {
			yield put({
				type: userConstants.UserRoleSaveSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: userConstants.UserRoleSaveFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: userConstants.UserRoleSaveFailure, payload: error });
	}
}

function* userAccountUpdate(request: any) {
	try {
		const result = yield call(UserService.userAccountUpdate, request.input);
		const res = exceptionHandler(result)
		if (res.status) {
			yield put({
				type: userConstants.userAccountUpdateSuccess,
				payload: res.data,
				user: request.input.user
			});
		}
		else {
			yield put({ type: userConstants.userAccountUpdateFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: userConstants.userAccountUpdateFailure, payload: error });
	}
}

function* userGetShopifyAddress(request: any) {
	try {
		const result = yield call(UserService.userGetShopifyAddress, request.input);
		const res = exceptionHandler(result)
		if (res.status) {
			yield put({
				type: userConstants.userGetShopifyAddressSuccess,
				payload: res.data.addresses
			});
		}
		else {
			yield put({ type: userConstants.userGetShopifyAddressFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: userConstants.userGetShopifyAddressFailure, payload: error });
	}
}

export const userSaga = {
	userSave,
	userGetDetail,
	userGetCountByYear,
	userGetByFilter,
	userDelete,
	userRoleGetByFilter,
	userRoleGet,
	userGetAddress,
	userGetPaymentsByFilter,
	userUpdateActiveStatus,
	userSaveCommunity,
	userSaveAddress,
	userRoleSave,
	userAccountUpdate,
	userGetShopifyAddress
}